import React, { useState } from "react";

//Bootstrap
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

//Data Files
import BrandingPackagesData from "../../Data/PackagesData/BrandingPackagesData";
import ComboPackagesData from "../../Data/PackagesData/ComboPackagesData";
import ECommercePackagesData from "../../Data/PackagesData/ECommercePackagesData";
import SEOPackagesData from "../../Data/PackagesData/SEOPackagesData";
import VideoAnimationPackagesData from "../../Data/PackagesData/VideoAnimationPackagesData";
import WebDesignPackagesData from "../../Data/PackagesData/WebDesignPackagesData";

//Custom Comp
import PackagesTab from "./PackagesTab";

function PackagesTabsContainer() {
  const [key, setKey] = useState("web-design");

  return (
    <Tabs
      id="controlled-tab-example"
      activeKey={key}
      onSelect={(k) => setKey(k)}
      mountOnEnter
      className="filters mb-3"
      style={{
        listStyle: "none",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        position: "relative",
        padding: "12px 15px",
        textTransform: "uppercase",
        color: "#222 !important",
        backgroundColor: "transparent !important",
        fontSize: "12px",
        fontWeight: "500",
        border: "none",
      }}
    >
      <Tab eventKey="web-design" title="Web Design">
        <PackagesTab data={WebDesignPackagesData} carousel={false} />
      </Tab>

      <Tab eventKey="e-commerce" title="E-Commerce">
        <PackagesTab data={ECommercePackagesData} carousel={false} />
      </Tab>

      <Tab eventKey="seo" title="SEO">
        <PackagesTab data={SEOPackagesData} carousel={false} />
      </Tab>

      <Tab
        style={{ border: "none", textTransform: "Uppercase" }}
        eventKey="branding"
        title="Branding"
      >
        <PackagesTab data={BrandingPackagesData} carousel={false} />
      </Tab>

      <Tab eventKey="video-animation" title="Video / Animation">
        <PackagesTab data={VideoAnimationPackagesData} carousel={false} />
      </Tab>

      <Tab eventKey="combo" title="Combo Pack">
        <PackagesTab data={ComboPackagesData} carousel={false} />
      </Tab>
    </Tabs>
  );
}

export default PackagesTabsContainer;
